import { ReactComponent as EditRoomTimeSvg } from "../../assets/images/svgs/editRoomTime.svg";

const EditRoomTimeIcon = ({ className = "", ...props }) => {
  return (
    <EditRoomTimeSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default EditRoomTimeIcon;
